const EspaciosTabItem = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="23"
            viewBox="0 0 26 23"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_531_287)">
                <path
                    d="M13.62 4.78854C15.21 4.82854 15.51 5.30854 15.63 5.51854L15.68 5.58855C15.88 5.89855 16.16 6.84855 16.28 7.37855L16.77 9.63855L16.95 10.4585L17.79 10.4185C17.79 10.4185 18.28 10.3985 18.81 10.3985C19.12 10.3985 19.34 10.3985 19.5 10.4185C19.15 12.2585 18.02 18.2785 17.98 18.6685C17.96 18.7685 17.81 19.0085 17.7 19.1685C17.56 19.1985 17.33 19.2285 17.16 19.2285H3.53001C3.10001 19.2285 2.74001 19.1685 2.55001 19.0985C2.46001 18.8785 2.34001 18.3685 2.29001 17.8985C2.28001 17.8285 1.23001 11.3985 1.03001 10.0685C1.08001 10.0485 1.14001 10.0185 1.19001 9.99854H3.70001L3.74001 9.03854C3.78001 8.03854 3.92001 6.93854 4.03001 6.68854C4.29001 6.09855 4.49001 5.75854 5.10001 5.16855C5.32001 4.95854 6.18001 4.77854 6.77001 4.75854H13.62M13.63 3.75854H6.78001C6.78001 3.75854 5.07001 3.81854 4.41001 4.45854C3.70001 5.14855 3.42001 5.58854 3.12001 6.28854C2.83001 6.93854 2.75001 8.99854 2.75001 8.99854H1.06001C1.06001 8.99854 -0.0999905 9.24854 9.45525e-06 10.0485C0.110009 10.8485 1.29001 18.0685 1.29001 18.0685C1.29001 18.0685 1.47001 19.6285 1.90001 19.9085C2.34001 20.1885 3.11001 20.2385 3.52001 20.2385H17.15C17.15 20.2385 18.18 20.2185 18.4 19.9085C18.62 19.5985 18.93 19.1785 18.97 18.7985C19.01 18.4085 20.48 10.6185 20.48 10.6185C20.48 10.6185 20.66 9.60854 20.06 9.48854C19.78 9.42854 19.28 9.41854 18.81 9.41854C18.25 9.41854 17.74 9.43854 17.74 9.43854L17.25 7.17854C17.25 7.17854 16.91 5.66854 16.52 5.05854C16.32 4.74854 15.9 3.84854 13.63 3.79854V3.75854Z"
                    fill="#686058"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.87 20.7786H6.28L5.96 21.9686C5.88 22.2586 5.59 22.4586 5.26 22.4586H4.9C4.57 22.4586 4.28 22.2586 4.2 21.9686L3.88 20.7786H3.87Z"
                    fill="#686058"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.24 20.7786H16.65L16.33 21.9686C16.25 22.2586 15.96 22.4586 15.63 22.4586H15.27C14.94 22.4586 14.65 22.2586 14.57 21.9686L14.25 20.7786H14.24Z"
                    fill="#686058"
                />
                <path
                    d="M2.51001 9.47854H3.54001C3.54001 9.47854 3.76001 9.44854 4.04001 9.84854C4.26001 10.1585 4.69001 13.0385 4.96001 14.5985C5.03001 15.0085 5.34001 15.3085 5.69001 15.3085L15.25 15.5285C15.59 15.5285 15.88 15.2685 15.97 14.8785C15.97 14.8785 17.07 10.2885 17.18 10.0785C17.29 9.86854 17.83 9.86854 17.83 9.86854"
                    stroke="#686058"
                    strokeMiterlimit="10"
                />
                <path
                    d="M0.410034 20.5386H20.52"
                    stroke="white"
                    strokeWidth="0.75"
                    strokeMiterlimit="10"
                />
                <path
                    d="M17.66 3.3585V1.7285C17.66 1.5785 17.78 1.4585 17.92 1.4585H25.12C25.27 1.4585 25.38 1.5785 25.38 1.7285V5.8385C25.38 5.9885 25.26 6.1085 25.12 6.1085H18.29C18.05 6.1085 17.94 5.8085 18.1 5.6385L19.52 4.1685C19.62 4.0585 19.79 4.0585 19.89 4.1685L20.77 4.6085C20.87 4.7185 21.04 4.7185 21.14 4.6085L22.77 3.3885C22.87 3.2785 23.04 3.2785 23.14 3.3885L23.64 4.1085"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_531_287">
                    <rect
                        width="25.89"
                        height="21.5"
                        fill="white"
                        transform="translate(0 0.958496)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default EspaciosTabItem
